


import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Dialog, NoticeResponse } from '@kasasa/fbase-components/lib';

@Component({
	components: {},
}) 
export default class FormPage extends Vue {
	inputComponents: string[] = ['k-checkbox', 'k-radio-group', 'k-select', 'k-switch', 'k-textarea', 'k-text'];
	containerSelectors: string[] = ['v-form'];

	created(): void {
		this.$on('data-updated', this.resetInitialValues);
	}

	setContainerSelectors(containerSelectors: string[]): void {
		this.containerSelectors = containerSelectors;
	}

	/* eslint-disable-next-line */
	async beforeRouteLeave (routeFrom: Route, routeTo: Route, next: Function) {
		next(await this.continueNavigation());
	}

	/* eslint-disable-next-line */
	async beforeRouteUpdate (routeFrom: Route, routeTo: Route, next: Function) {
		next(await this.continueNavigation());
	}

	async continueNavigation(): Promise<boolean> {
		if (!this.isDataDirty()) {
			return true;
		}

		const dialog = new Dialog('Unsaved Changes', 'You have unsaved changes on this page that will be lost if you leave now. Are you sure you want to leave without saving?', 'LEAVE WITHOUT SAVING')
			.setDeclineLabel('STAY ON THIS PAGE')
			.setDismissable(false);
		const res = await this.$store.dispatch('notices/add', dialog);
		switch (res) {
			case NoticeResponse.ACCEPT:
				return true;
			case NoticeResponse.DECLINE:
			default:
				return false;
		}
	}

	isDataDirty(): boolean {
		const inputComponents = this.findInputComponents(this);
		/* eslint-disable-next-line */
		return inputComponents.some((component) => (component as any).isDirty());
	}

	resetInitialValues(): void {
		const inputComponents = this.findInputComponents(this);
		inputComponents.forEach((component: Vue) => {
			/* eslint-disable-next-line */
			(component as any).resetInitialValue();
		});
	}

	findInputComponents(component: Vue, inContainerParam = false): Vue[] {
		let inContainer = inContainerParam;
		let foundComponents: Vue[] = [];
		const meta: { tag: string; id: string; class: string[] } = {
			tag: '',
			id: '',
			class: [],
		};

		// find component meta data
		if (component.$vnode.componentOptions && component.$vnode.componentOptions.tag != undefined) {
			meta.tag = component.$vnode.componentOptions.tag;
		}

		if (component.$vnode.data) {
			if (component.$vnode.data.attrs && component.$vnode.data.attrs.id != undefined) {
				meta.id = '#' + component.$vnode.data.attrs.id;
			}

			if (component.$vnode.data.staticClass != undefined) {
				component.$vnode.data.staticClass.split(' ').forEach((className) => {
					meta.class.push('.' + className);
				});
			}
		}

		// check if inContainer
		if (!inContainer
			&& (
				this.containerSelectors.includes(meta.tag)
				|| this.containerSelectors.includes(meta.id)
				|| meta.class.some(className => this.containerSelectors.includes(className))
			)) {
			inContainer = true;
		}

		// check if input is found inContainer
		if (inContainer && this.inputComponents.includes(meta.tag)) {
			foundComponents.push(component as Vue);

		} else { // search component's children
			component.$children.forEach((child) => {
				foundComponents = foundComponents.concat(this.findInputComponents(child, inContainer));
			});
		}

		return foundComponents;
	}

}
